<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ShuFang`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.3066 12.6667V6.75C11.3066 4.67894 9.62768 3 7.55663 3H3.05664C2.22821 3 1.55664 3.67157 1.55664 4.5V16.8333C1.55664 17.6618 2.22821 18.3333 3.05664 18.3333H8.03565C8.19263 18.3333 8.34338 18.3954 8.4549 18.506C9.84765 19.8869 12.0932 19.8869 13.486 18.506C13.5975 18.3954 13.7482 18.3333 13.9052 18.3333H19.5566C20.3851 18.3333 21.0566 17.6618 21.0566 16.8333V6.66667" stroke="#333" stroke-linecap="round"/><path d="M11.3047 13V6.75C11.3047 4.67893 12.9836 3 15.0547 3H17.6927M21.0573 6.33333V4.5C21.0573 3.67157 20.3858 3 19.5573 3H17.6953M3 6H8.25M3 9H8.25M14.25 6H19.5M14.25 9H19.5" stroke="#333" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconShuFang',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
